import { useToolEditorContext } from "components/ToolEditor/Provider/ToolEditorProvider";
import { ParamsEditorRowDatum } from "components/ToolEditor/ToolEditor.types";
import {
  FieldChoices,
  FieldChoicesProps,
} from "pages/gdt/modals/fields/FieldChoices";
import { useCallback } from "react";

interface DetailRendererStringChoiceParamProps {
  data: ParamsEditorRowDatum & {
    type: Extract<
      ParamsEditorRowDatum["type"],
      { param_type: "ToolChoiceParam" }
    >;
  };
  editMode?: boolean;
}

export const DetailRendererStringChoiceParam = ({
  data,
}: DetailRendererStringChoiceParamProps) => {
  const updateSpecParam = useToolEditorContext((s) => s.updateSpecParam);

  const onChange: FieldChoicesProps["onChange"] = useCallback(
    (vals) => {
      updateSpecParam(
        data.key,
        "ToolChoiceParam",
        {
          choices: vals.map((val) => String(val.value)),
          display_options: vals.map((val) => String(val.value)),
        },
        true,
      );
    },
    [data.key, updateSpecParam],
  );

  return (
    <FieldChoices
      autoFocus
      value={data.type.choices.map((choice) => ({
        label: String(choice),
        value: String(choice),
      }))}
      onChange={onChange}
      // intentionally empty to suppress default text from gdt component
      helpText=""
    />
  );
};
